import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import SaveIcon from '@material-ui/icons/Save';
import React from 'react';
import { Box } from '../../../UI';

export default function General({ data }) {
	const { type, inflation, leakage, vacancy, leaseRenewal, tenantIncentive, vacancyCost } = data;
	return (
		<ExpansionPanel style={{ background: '#eee' }}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>General Assumptions</strong>
					<Tooltip title="General underwriting assumptions to be inserted by the user" aria-label="info">
						<IconButton color="inherit" aria-label="menu">
							<InfoIcon style={{ fontSize: '16px' }} color="primary" />
						</IconButton>
					</Tooltip>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				<Box display="flex" flexDirection="column" width="100%">
					<TableContainer style={{ height: '431px' }}>
						<Table aria-label="simple table">
							<TableBody>
								<TableRow>
									<TableCell align="left">
										<strong>Transaction Type</strong>
									</TableCell>
									<TableCell align="right">{type}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Inflation</strong>
									</TableCell>
									<TableCell align="right">{inflation}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Operating Leakage/cost (% of GRI)</strong>
									</TableCell>
									<TableCell align="right">{leakage}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Fill Vacancy (Y/N)</strong>
									</TableCell>
									<TableCell align="right">{vacancy}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Lease renewals probability (%)</strong>
									</TableCell>
									<TableCell align="right">{leaseRenewal}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Tenant Incentives (% of GRI)</strong>
									</TableCell>
									<TableCell align="right">{tenantIncentive}%</TableCell>
								</TableRow>
								<TableRow>
									<TableCell align="left">
										<strong>Vacancy Cost (per sq ft)</strong>
									</TableCell>
									<TableCell align="right">£{vacancyCost.toFixed(2)}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					<Box display="flex" justifyContent="flex-end" mt="1rem">
						<Button variant="contained" color="primary" startIcon={<SaveIcon />}>
							Save changes
						</Button>
					</Box>
				</Box>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}
